import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import classnames from 'classnames';

// must be defined outside of the component to avoid re-rendering loops
const defaultHandleClose = () => {};
const UploadMessage = _ref => {
  let _ref$handleClose = _ref.handleClose,
    handleClose = _ref$handleClose === void 0 ? defaultHandleClose : _ref$handleClose,
    _ref$failedToUpload = _ref.failedToUpload,
    failedToUpload = _ref$failedToUpload === void 0 ? [] : _ref$failedToUpload,
    _ref$files = _ref.files,
    files = _ref$files === void 0 ? [] : _ref$files;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'auto',
      maxHeight: '400px'
    },
    className: "t-notification-upload"
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('tqc-notification-info-header', 't-notification-header')
  }, "You have uploaded ", files.length, " file", files.length > 1 ? 's' : '', ":"), files.length + failedToUpload.length > 22 ? '\n(panel is scrollable)' : '', /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), files.map(i => /*#__PURE__*/React.createElement("span", {
    key: Math.random()
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-file-upload-".concat(i, "-succeess"),
    style: {
      color: 'green'
    }
  }, "\u2714\uFE0E"), " ", i.displayName, /*#__PURE__*/React.createElement("br", null))), failedToUpload.map(i => /*#__PURE__*/React.createElement("span", {
    key: Math.random()
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-file-upload-".concat(i, "-failure"),
    style: {
      color: 'red'
    }
  }, "\uD800\uDD02"), " ", i.displayName, /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: () => handleClose(),
    className: classnames('t-notification-button-left', 't-nbl-label-ok')
  }, "OK"));
};
UploadMessage.propTypes = {
  handleClose: PropTypes.func,
  files: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string
  })),
  failedToUpload: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string
  }))
};
export default UploadMessage;